////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'

//////STYLED//////
const TelecollectDetailSaleStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => props.colorCode};
	color: ${(props) => props.theme.colors.white};
	line-height: 32px;
	font-weight: bold;
	padding: 0px 10px;
`
//////STYLED//////

const TelecollectDetailSaleStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TelecollectDetailSaleStatusWrapper colorCode={props.row.salesOrderStatus.colorCode}>
			{translations[props.row.salesOrderStatus.translationKey]}
		</TelecollectDetailSaleStatusWrapper>
	)
}

TelecollectDetailSaleStatus.propTypes = {}

TelecollectDetailSaleStatus.defaultPropTypes = {}

export default TelecollectDetailSaleStatus
